import type { IBreadcrumbs } from './breadcrumbs';
import type {
  IMirrorSeoBodyComponent,
  IMirrorSeoHeadComponent,
  ISeoHeadComponent,
} from './seoHead';
import type { IStrapiImage } from './strapiImage';

export enum EProviderType {
  Games = 'games',
  Slots = 'slots',
}

export interface IProviderData {
  id: number;
  createdAt: Date;
  updatedAt: Date;
  publishedAt?: Date;
  providerId: string;
  stageOnly?: boolean;
  head: ISeoHeadComponent;
  descriptionText?: string;
  descriptionHiddenText?: string;
  autoLinkFormat?: boolean;
  providerTitle: string;
  providerIcon?: IStrapiImage;
  breadcrumbs: IBreadcrumbs[];
  type: EProviderType;
  hideOnProvidersPage?: boolean;
  mirrorHead: IMirrorSeoHeadComponent[];
  mirrorBody: IMirrorSeoBodyComponent[];
  providerIconWide?: IStrapiImage;
  position?: number;
  positionByGeo:
    | {
        geo: string;
        position: number;
      }[]
    | null;
  no2GamesMode?: boolean;
  no4GamesMode?: boolean;
  showForEstonia?: boolean;
  isPage?: boolean;
  locale: string;
}

export interface IProvidersDataExtended extends IProviderData {
  restricted: boolean;
}

export interface IProviderStrapiResponse {
  data: IProviderData[];
}
